import styled, { css, keyframes } from "styled-components";
import { color, highContrastStyle, onHover } from "@m/alchemy-theme";
import { NakedButton } from "../naked-button/NakedButton";
const fade = keyframes `
    from {
        opacity: 1;
    }
    to {
        opacity: 0.21;
    }
`;
const speed = 1.34;
export const MoreMenuButton = styled(NakedButton) `
  color: ${({ activeColorScheme }) => (activeColorScheme === "alchemyBrand" ? color("base") : color("typeMeta"))};

  svg {
    color: currentColor;
    transition: all 0.2s ease-in;
  }

  ${({ activeColorScheme }) => activeColorScheme === "alchemyBrand"
    ? css `
          opacity: ${highContrastStyle("1", "0.85")};
        `
    : css ``}

  ${({ isLoading }) => isLoading &&
    css `
      svg circle {
        animation: ${fade} ${speed / 2}s infinite alternate;
        transition: opacity ${speed}s linear;
        &:nth-child(2) {
          animation-delay: 0.17s;
        }
        &:nth-child(3) {
          animation-delay: 0.34s;
        }
      }
    `};

  ${({ activeColorScheme }) => activeColorScheme === "alchemyBrand"
    ? onHover(css `
          opacity: 1;
        `)
    : onHover(css `
          color: ${color("base", { palette: "interactiveConstructive" })};
        `)}

  // Override the default focus styles coming from onHover
  ${({ activeColorScheme }) => {
    if (activeColorScheme === "alchemyBrand") {
        return css `
        &:enabled:focus {
          opacity: 1;
          svg {
            color: ${color("base")};
          }
        }
      `;
    }
    return css `
      &:enabled:focus {
        opacity: 1;
        svg {
          color: ${color("base", { palette: "interactiveConstructive" })};
        }
      }
    `;
}}
`;
